import domReady from '@wordpress/dom-ready';
import { registerPlugin } from '@wordpress/plugins';
import CollectionMetaData from './collection-metadata';
import FilterSidebar from './filter-report-sidebar'

domReady(() => {
  if (wp.plugins && wp.plugins.registerPlugin) {
    registerPlugin('collection-meta-data-settings', { render: CollectionMetaData });
    registerPlugin('filter-report-sidebar', { render: FilterSidebar });
  }
});